export enum FileUploadKeys {
    AudioLengthSeconds = "AudioLengthSeconds",
    AudioFileSizeBytes = "AudioFileSizeBytes",
    AudioFileExtension = "AudioFileExtension",
    TotalUploadDuration = "TotalUploadDuration",
    TranscriptionProcessDuration = "TranscriptionProcessDuration",
    AddMinutesUsedDuration = "AddMinutesUsedDuration",
    FailureReason = "FailureReason",
    FrontDoorSessionId = 'FrontDoorSessionId',
    EstimatedTranscriptionTimeAsPercentageOfAudioLength = 'EstimatedTranscriptionTimeAsPercentageOfAudioLength',
    PreeliminaryAudioLengthUnavailable = 'PreeliminaryAudioLengthUnavailable',
    ServiceFileDurationSeconds = 'ServiceFileDurationSeconds',
    GetFileDurationDurationSeconds = 'GetFileDurationDurationSeconds',
    TranscriptionLocale = 'TranscriptionLocale',
    IsNewFileUploadDesign = 'IsNewFileUploadDesign',
    AudioFileMIMEType = 'AudioFileMIMEType',
    BatchTranscriptionClientRequestPollerMessageLog = `BatchTranscriptionClientRequestPollerMessageLog`,
    CorrelationId = 'CorrelationId',
    FileExecuteComplete = 'FileExecuteComplete',
    WriteContentToClientStorageDuration = 'WriteContentToClientStorageDuration',
    FileUploadHistoryDump = 'FileUploadHistoryDump',
    FileUploadForegroundTaskError = 'FileUploadForegroundTaskError',
};